import React from 'react';
import ShopTalk from 'views/DashboardPage/ShopTalkPage/ShopTalk';
import Drawer from '@material-ui/core/Drawer';

export default function ShopTalkDrawer({ open, onClose, ...rest }) {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <ShopTalk {...(rest || {})} />
    </Drawer>
  );
}
